import React from "react";

import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * @see Tooltip
 */

type IgAnalyticsTooltipProps = TooltipProps & {
  maxWidth?: string | number;
};

export const IgAnalyticsTooltip = styled(
  ({ maxWidth, className, placement, ...props }: IgAnalyticsTooltipProps) => (
    <Tooltip
      {...props}
      placement={placement ?? "top"}
      classes={{ popper: className }}
    >
      <span>{props.children}</span>
    </Tooltip>
  )
)(({ maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth,
    backgroundColor: "#494C50",
    "& .MuiTypography-root": {
      color: "white",
      fontSize: "12px",
      linHeight: "16px",
    },
  },
}));
